import { installStripeLinkTrustSync } from '~/composables/installStripeLinkTrustSync'

export default defineNuxtPlugin(() => {
  installStripeLinkTrustSync()
})
